import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../utils/queries'

const BitaEmp2 = ({styles, argsBuscEstruct, listaE}) => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*1.1

  // let listEmpresa = listaE
  // let indexEmp = listEmpresa.findIndex( empresa => empresa.descrEmpresa===argsBuscEstruct.descrEmpresa )
  // let rutaBita = listEmpresa[indexEmp].rutaBitacora?listEmpresa[indexEmp].rutaBitacora:'N'
  let rutaBita = 'https://lookerstudio.google.com/embed/reporting/5e263d06-9fc6-4458-bce4-e9bffcfb4e1d/page/sIgGD'

  return (
    <div>
      {rutaBita!=='N' &&
        <iframe width={ancho} height={alto} src={rutaBita}></iframe>
      }
    </div>
  )
}
export default compose(
  graphql(queries.query.allEmpresa, {name:'allEmpresa'})
)(BitaEmp2)